// extracted by mini-css-extract-plugin
export default {"bank":"bank_bank__EIbi8"};